(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7130],{

/***/ 12802:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage/[...location]",
      function () {
        return __webpack_require__(26158);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CanonicalURL; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55088);




function CanonicalURL() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: (0,_utility__WEBPACK_IMPORTED_MODULE_3__/* .getCanonicalURL */ .DN)(router)
        })
    });
}


/***/ }),

/***/ 66115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _404; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
;// CONCATENATED MODULE: ./public/images/error_404.png
/* harmony default export */ var error_404 = ({"src":"/_next/static/media/error_404.f1ddc8fc.png","height":351,"width":392,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAVFBMVEVMaXHT1NPPy8vq6uquqaq/v8C4tLTFs7Xp6ure397ayMrg19jv8vKem5zMysrExMTV1dTAwMDBxMTKfobHkJbLvb7s8fHs7u2zmJvIyMjY2Njd3d2qQk9TAAAAG3RSTlMAhbb5W24qFtOZ4vV/e2L6yk02bsTX155CeeRf4oh3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nCXGSRKAIAwEwGFNIiLKoiL//yel9qmBNSyMF23RfgEl9ycP5Q6PAqsVPztq074bM3Cy0H2JTCzDAdsSyHf/AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/pages/404.tsx












var PageNotFound = function() {
    var locale = (0,router.useRouter)().locale;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var isContext = !!headerFooter[0];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData, brands;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sv-page-content error-page",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-lg-6 col-md-9 col-sm-12 mx-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "error-brief",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "error-img",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    sizes: "(max-width: 375px) 220px, (max-width: 576px) 395px, (max-width: 768px) 400px, (max-width: 992px) 400px, (max-width: 1280px) 400px",
                                    src: error_404,
                                    alt: "404",
                                    className: "img-fluid",
                                    height: "300",
                                    width: "300"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "error-heading",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pnf-msg"
                                    }),
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "para",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "pnf-desc"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/self-storage",
                                prefetch: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn sv-primary-red-btn",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "pnf-find"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var _404 = (PageNotFound);


/***/ }),

/***/ 26158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _location_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/common/Canonical.tsx
var Canonical = __webpack_require__(83664);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/services/home/index.ts
var home = __webpack_require__(66156);
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/pages/404.tsx + 1 modules
var _404 = __webpack_require__(66115);
;// CONCATENATED MODULE: ./src/components/store-locator/city-component.tsx
/* eslint-disable */ 




var CityLandingComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(4585), __webpack_require__.e(395), __webpack_require__.e(1909), __webpack_require__.e(5675), __webpack_require__.e(6173), __webpack_require__.e(3069)]).then(__webpack_require__.bind(__webpack_require__, 30699));
});







var CityComponent = function(props) {
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var vehicleLandingPage = props.vehicleLandingPage;
    var ref = (0,react.useState)([]), unitsInfo = ref[0], setUnitsInfo = ref[1];
    var ref1 = (0,react.useState)(), cityInfo = ref1[0], setCityInfo = ref1[1];
    var ref2 = (0,react.useState)(null), brandCta = ref2[0], setBrandCta = ref2[1];
    var mapCords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var ref3 = (0,react.useState)(), ordinate = ref3[0], setOrdinate = ref3[1];
    var locale = (0,next_router.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var ref4 = (0,react.useState)(false), err = ref4[0], setErr = ref4[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData, brands, Cta;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        brands = contextData === null || contextData === void 0 ? void 0 : contextData.data;
                        Cta = brands && brands[0] && brands[0].attributes && brands[0].attributes.CTA_Section;
                        setBrandCta(Cta);
                        headerFooterData.setHeaderFooterData(brands);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var obj = {
            lat: parseFloat(cityInfo === null || cityInfo === void 0 ? void 0 : (ref = cityInfo.attributes) === null || ref === void 0 ? void 0 : ref.Latitude),
            lng: parseFloat(cityInfo === null || cityInfo === void 0 ? void 0 : (ref1 = cityInfo.attributes) === null || ref1 === void 0 ? void 0 : ref1.Longitude)
        };
        setOrdinate(obj);
        return function() {
            mapCords.setLatLogCity({});
        };
    }, []);
    var getFacilityData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, defaultBrand, slug, cityResult, newArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        slug = props === null || props === void 0 ? void 0 : props.city;
                        if (locale === "fr") {
                            defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                            slug = "".concat(props === null || props === void 0 ? void 0 : props.city, "-fr");
                        }
                        return [
                            4,
                            Promise.all([
                                (0,home/* getRightUnitInfo */.Zy)(defaultBrand, locale),
                                vehicleLandingPage ? (0,home/* getVehicleLandingData */.co)(slug, defaultBrand, locale) : (0,home/* getCityLandingInfo */.fC)(slug, defaultBrand, locale)
                            ])
                        ];
                    case 1:
                        cityResult = _state.sent();
                        setUnitsInfo((ref = cityResult[0]) === null || ref === void 0 ? void 0 : ref.data);
                        setCityInfo((ref1 = cityResult[1]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.data) === null || ref2 === void 0 ? void 0 : ref2.data[0]);
                        newArray = [
                            {
                                lan: (ref5 = (ref3 = cityResult[1]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.data[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : ref6.locale,
                                slugValue: (ref9 = (ref7 = cityResult[1]) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : ref8.data[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.attributes) === null || ref10 === void 0 ? void 0 : ref10.Slug
                            },
                            {
                                lan: (ref16 = (ref13 = (ref11 = cityResult[1]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.data) === null || ref12 === void 0 ? void 0 : ref12.data[0]) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.localizations) === null || ref15 === void 0 ? void 0 : ref15.data[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.attributes) === null || ref17 === void 0 ? void 0 : ref17.locale,
                                slugValue: (ref23 = (ref20 = (ref18 = cityResult[1]) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.data) === null || ref19 === void 0 ? void 0 : ref19.data[0]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.attributes) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.localizations) === null || ref22 === void 0 ? void 0 : ref22.data[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Slug
                            }
                        ];
                        if (newArray[0].lan) {
                            sessionStorage.setItem("facCords", JSON.stringify(newArray));
                        }
                        if (((ref25 = cityResult[1]) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.data) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.data) === null || ref27 === void 0 ? void 0 : ref27.length) === 0) {
                            setErr(true);
                        } else {
                            setErr(false);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function getFacilityData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFacilityData();
    }, [
        locale,
        location
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !err && cityInfo && brandCta && unitsInfo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CityLandingComponent, {
                cords: ordinate,
                cityLandingInfo: cityInfo,
                ourBrandsData: brandCta,
                bodyData: unitsInfo,
                hostUrl: props === null || props === void 0 ? void 0 : props.hostUrl,
                vehicleLandingPage: vehicleLandingPage
            }),
            err && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
/* harmony default export */ var city_component = (CityComponent);

;// CONCATENATED MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
/*! js-cookie v3.0.5 | MIT */
/* eslint-disable no-var */
function js_cookie_assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      target[key] = source[key];
    }
  }
  return target
}
/* eslint-enable no-var */

/* eslint-disable no-var */
var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init (converter, defaultAttributes) {
  function set (name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = js_cookie_assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get (name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        jar[found] = converter.read(value, found);

        if (name === found) {
          break
        }
      } catch (e) {}
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set,
      get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          js_cookie_assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, js_cookie_assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(js_cookie_assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });
/* eslint-enable no-var */



;// CONCATENATED MODULE: ./src/components/store-locator/facility-component.tsx
/* eslint-disable */ 




var LocationLanding = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(1255), __webpack_require__.e(9238), __webpack_require__.e(4585), __webpack_require__.e(7536), __webpack_require__.e(1909), __webpack_require__.e(804), __webpack_require__.e(696), __webpack_require__.e(4544), __webpack_require__.e(5625), __webpack_require__.e(3752), __webpack_require__.e(606), __webpack_require__.e(5675), __webpack_require__.e(3389), __webpack_require__.e(3022), __webpack_require__.e(6902)]).then(__webpack_require__.bind(__webpack_require__, 8502));
});





var FacilityComponent = function(props) {
    var ref;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var headerInfo = (ref = headerFooterData === null || headerFooterData === void 0 ? void 0 : headerFooterData.headerFooter[0]) === null || ref === void 0 ? void 0 : ref.attributes;
    var ref1 = (0,react.useState)(null), facilityInfo = ref1[0], setFaciltyInfo = ref1[1];
    var ref2 = (0,react.useState)(null), articleInfo = ref2[0], setArticleInfo = ref2[1];
    var mapCords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var facilityData = props === null || props === void 0 ? void 0 : props.facilityData;
    var reviewsData = props.reviewsData, unitData = props.unitData, promotions = props.promotions;
    var locale = (0,next_router.useRouter)().locale;
    var isContext = !!headerFooter[0];
    var location = props === null || props === void 0 ? void 0 : props.facility;
    var ref3 = (0,react.useState)(false), err = ref3[0], setErr = ref3[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, brands;
            return (0,tslib_es6.__generator)(this, function(_state) {
                brands = props === null || props === void 0 ? void 0 : (ref = props.brandData) === null || ref === void 0 ? void 0 : ref.data;
                headerFooterData.setHeaderFooterData(brands);
                return [
                    2
                ];
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getFacilityData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, matched, ref25, ref26, coords, splicedStr, frSlug, enSlug, split, ref27, facilitySlugResData, ref28, ref29, ref30, ref31, ref32, citySlug, multiFacility, newArray;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (locale === "fr") {
                    if ((props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) location = "".concat(props === null || props === void 0 ? void 0 : props.facility, "-fr");
                    else location = "".concat(props === null || props === void 0 ? void 0 : props.facility);
                }
                matched = false;
                if (sessionStorage.getItem("facCords")) {
                    ;
                    coords = JSON.parse(sessionStorage.getItem("facCords"));
                    ;
                    frSlug = (ref25 = coords.find(function(e) {
                        return e.lan === "fr";
                    })) === null || ref25 === void 0 ? void 0 : ref25.slugValue;
                    enSlug = (ref26 = coords.find(function(e) {
                        return e.lan === "en";
                    })) === null || ref26 === void 0 ? void 0 : ref26.slugValue;
                    split = frSlug.split("-");
                    splicedStr = split.slice(0, split.length - 1).join("-");
                    if (splicedStr === (props === null || props === void 0 ? void 0 : props.facility) || enSlug === (props === null || props === void 0 ? void 0 : props.facility)) {
                        if ((props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) matched = true;
                    }
                    if (matched) {
                        ;
                        location = (ref27 = coords.find(function(e) {
                            return e.lan === locale;
                        })) === null || ref27 === void 0 ? void 0 : ref27.slugValue;
                    }
                }
                facilitySlugResData = facilityData;
                // Blog related information based on facility,city or default.
                if ((facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref = facilitySlugResData.attributes) === null || ref === void 0 ? void 0 : (ref1 = ref.Blog) === null || ref1 === void 0 ? void 0 : ref1.data) !== null) {
                    setArticleInfo(facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : facilitySlugResData.attributes);
                } else if ((facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref2 = facilitySlugResData.attributes) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Blog) === null || ref3 === void 0 ? void 0 : ref3.data) === null && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref4 = facilitySlugResData.attributes) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.City) === null || ref5 === void 0 ? void 0 : ref5.data) !== null && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref6 = facilitySlugResData.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.City) === null || ref7 === void 0 ? void 0 : ref7.data.hasOwnProperty("attributes")) && (facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref8 = facilitySlugResData.attributes) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.City) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.data) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.Blog) === null || ref12 === void 0 ? void 0 : ref12.data) !== null) {
                    ;
                    setArticleInfo(facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref28 = facilitySlugResData.attributes) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.City) === null || ref29 === void 0 ? void 0 : (ref30 = ref29.data) === null || ref30 === void 0 ? void 0 : ref30.attributes);
                } else {
                    ;
                    setArticleInfo((ref32 = props === null || props === void 0 ? void 0 : (ref31 = props.brandData) === null || ref31 === void 0 ? void 0 : ref31.data[0]) === null || ref32 === void 0 ? void 0 : ref32.attributes);
                }
                citySlug = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref13 = facilitySlugResData.attributes) === null || ref13 === void 0 ? void 0 : ref13.City_Slug;
                multiFacility = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref14 = facilitySlugResData.attributes) === null || ref14 === void 0 ? void 0 : ref14.multiFacility;
                if (facilitySlugResData && Object.keys(facilitySlugResData).length === 0 || multiFacility && citySlug !== (props === null || props === void 0 ? void 0 : props.city) && citySlug != undefined || facilitySlugResData === undefined) {
                    setErr(true);
                } else {
                    setErr(false);
                }
                setFaciltyInfo(facilitySlugResData);
                newArray = [
                    {
                        lan: facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref15 = facilitySlugResData.attributes) === null || ref15 === void 0 ? void 0 : ref15.locale,
                        slugValue: facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref16 = facilitySlugResData.attributes) === null || ref16 === void 0 ? void 0 : ref16.Slug
                    },
                    {
                        lan: (ref19 = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref17 = facilitySlugResData.attributes) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.localizations) === null || ref18 === void 0 ? void 0 : ref18.data[0]) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.attributes) === null || ref20 === void 0 ? void 0 : ref20.locale,
                        slugValue: (ref23 = facilitySlugResData === null || facilitySlugResData === void 0 ? void 0 : (ref21 = facilitySlugResData.attributes) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.localizations) === null || ref22 === void 0 ? void 0 : ref22.data[0]) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.attributes) === null || ref24 === void 0 ? void 0 : ref24.Slug
                    }
                ];
                if (newArray[0].lan && (props === null || props === void 0 ? void 0 : props.checkQueryLen) === 2) {
                    sessionStorage.setItem("facCords", JSON.stringify(newArray));
                    api.set("facCords", JSON.stringify(newArray));
                }
                return [
                    2
                ];
            });
        });
        return function getFacilityData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getFacilityData();
    }, [
        locale,
        location,
        props === null || props === void 0 ? void 0 : props.facilityData
    ]);
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    (0,react.useEffect)(function() {
        return function() {
            mapCords.setLatLog({});
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            facilityInfo && !err && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationLanding, {
                    facilityData: facilityInfo,
                    brandRelatedData: headerInfo,
                    articlesData: articleInfo,
                    reviewsData: reviewsData,
                    unitData: unitData,
                    promotions: promotions || []
                })
            }),
            err && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
/* harmony default export */ var facility_component = (FacilityComponent);

// EXTERNAL MODULE: ./src/components/utility.ts
var utility = __webpack_require__(55088);
;// CONCATENATED MODULE: ./src/pages/self-storage/[...location]/index.tsx










var Location = function(props) {
    var ref, ref1;
    var query = (0,next_router.useRouter)().query;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), facilityPage = ref2[0], setFacilityPage = ref2[1];
    var ref3 = (0,react.useState)(false), cityPage = ref3[0], setCityPage = ref3[1];
    var ref4 = (0,react.useState)(""), facilityName = ref4[0], setFacilityName = ref4[1];
    var ref5 = (0,react.useState)(""), cityName = ref5[0], setCityName = ref5[1];
    var facilityList = props === null || props === void 0 ? void 0 : (ref = props.cityData) === null || ref === void 0 ? void 0 : ref.data;
    var hostUrl = props.hostUrl, vehicleLandingPage = props.vehicleLandingPage, facilityData = props.facilityData, reviewsData = props.reviewsData, facilityInfo = props.facilityInfo, unitsresultsData = props.unitsresultsData;
    var ref6 = (0,react.useState)(null), checkQueryLen = ref6[0], setCheckQueryLen = ref6[1];
    var ref7 = (0,react.useState)(false), checkCity = ref7[0], setCheckCity = ref7[1];
    var ref8 = (0,react.useState)(false), error = ref8[0], setError = ref8[1];
    (0,react.useEffect)(function() {
        // Handling 404 errors
        if (query && query.location && query.location.length > 2) {
            setError(true);
        } else if (query && query.location && query.location.length === 2) {
            setCheckQueryLen(query.location.length);
            // For Facility pages(single,two)
            var city = query && query.location && query.location[0];
            var name = query && query.location && query.location[1];
            setFacilityPage(true);
            setCityPage(false);
            setCityName(city);
            setFacilityName(name);
        } else if (query && query.location && query.location.length === 1) {
            // For Vehicle pages
            var name1 = query && query.location && query.location[0];
            if (vehicleLandingPage) {
                setCityPage(true);
                setCityName(name1);
                setFacilityPage(false);
            } else {
                setCheckQueryLen(query.location.length);
                var filterLoc = facilityList.length === 0;
                if (filterLoc) {
                    // For Facility pages
                    setFacilityPage(true);
                    setFacilityName(name1);
                    setCityPage(false);
                } else {
                    // For City pages
                    setCityPage(true);
                    setCityName(name1);
                    setFacilityPage(false);
                }
            }
        }
        if ((facilityList === null || facilityList === void 0 ? void 0 : facilityList.length) === 0) {
            // Boolean value required in facility pages whether single slug or not
            setCheckCity(true);
        } else {
            setCheckCity(false);
        }
    }, [
        query.location,
        facilityList
    ]);
    var seoInfo = (0,utility/* getSEOProps */.RN)(props === null || props === void 0 ? void 0 : props.seoData, router);
    var faqStructuredData = (props === null || props === void 0 ? void 0 : props.seoFaqData) && (0,utility/* generateDynamicFAQ */.a4)(props === null || props === void 0 ? void 0 : (ref1 = props.seoFaqData) === null || ref1 === void 0 ? void 0 : ref1.Panel, true);
    var breadCrumbUrlList = (0,utility/* generateDynamicBCLD */.W_)(router);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seoInfo)),
            (props === null || props === void 0 ? void 0 : props.seoFaqData) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: faqStructuredData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Canonical/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* BreadcrumbJsonLd */.gR, {
                itemListElements: breadCrumbUrlList
            }),
            facilityData && unitsresultsData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* LocalBusinessJsonLd */.wq, (0,_object_spread/* default */.Z)({}, (0,utility/* generateLocalBusinessStructerData */.u3)(facilityData, unitsresultsData, reviewsData, router)))
            }),
            facilityPage && facilityName && facilityName.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facility_component, {
                    facility: facilityName,
                    facilityData: facilityInfo,
                    checkCity: checkCity,
                    city: cityName,
                    reviewsData: reviewsData,
                    unitData: unitsresultsData,
                    checkQueryLen: checkQueryLen,
                    brandData: props === null || props === void 0 ? void 0 : props.contextData,
                    promotions: props === null || props === void 0 ? void 0 : props.promotions
                })
            }),
            cityPage && cityName && cityName.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(city_component, {
                city: cityName,
                hostUrl: hostUrl,
                vehicleLandingPage: vehicleLandingPage,
                brandData: props === null || props === void 0 ? void 0 : props.contextData
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _location_ = (Location);


/***/ }),

/***/ 66156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Av": function() { return /* binding */ getConvenientLocations; },
/* harmony export */   "YW": function() { return /* binding */ getHeaderAndFooterDetailsWithDefaultLocale; },
/* harmony export */   "Zy": function() { return /* binding */ getRightUnitInfo; },
/* harmony export */   "co": function() { return /* binding */ getVehicleLandingData; },
/* harmony export */   "fC": function() { return /* binding */ getCityLandingInfo; },
/* harmony export */   "fU": function() { return /* binding */ getInnerPagesWithDefaultLocale; },
/* harmony export */   "k5": function() { return /* binding */ getBrandReviews; },
/* harmony export */   "ns": function() { return /* binding */ getGoogleReviews; },
/* harmony export */   "zc": function() { return /* binding */ getOurBrands; }
/* harmony export */ });
/* unused harmony exports getGoogleReview, getHomeBodyDetailsWithDefaultLocale, getStudentSpecialContent, getValidityCity */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getHeaderAndFooterDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getBrandLocaleUrl */ .oo(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHeaderAndFooterDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getHomeBodyDetailsWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var data = (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getHomeLocaleUrl */ .dK(brand, locale)), "get");
                        resolve(data);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function getHomeBodyDetailsWithDefaultLocale() {
        return _ref.apply(this, arguments);
    };
}();
var getBrandReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GOOGLE_CLIENT_REVIEWS */ .Zk), "get")
            ];
        });
    });
    return function getBrandReviews() {
        return _ref.apply(this, arguments);
    };
}();
var getOurBrands = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .GET_OUR_BRANDS */ .e), "get")
            ];
        });
    });
    return function getOurBrands() {
        return _ref.apply(this, arguments);
    };
}();
// for future lcode include
var getGoogleReviews = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReviews */ .Vf(lcode)), "get")
            ];
        });
    });
    return function getGoogleReviews(lcode) {
        return _ref.apply(this, arguments);
    };
}();
var getGoogleReview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lcode, locale) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getClientReview */ .tw(lcode, locale)), "get")
            ];
        });
    });
    return function getGoogleReview(lcode, locale) {
        return _ref.apply(this, arguments);
    };
}();
// lat, lng, brand, limit,
var getConvenientLocations = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(lang, cords) {
        var ncards;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            ncards = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 3;
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doDataVaultRequest */ .b0)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .CONVENIENT_LOCATIONS */ .vi, "?lat=").concat(cords === null || cords === void 0 ? void 0 : cords.latitude, "&lng=").concat(cords === null || cords === void 0 ? void 0 : cords.longitude, "&brand=as&limit=").concat(ncards, "&lang=").concat(lang), "get")
            ];
        });
    });
    return function getConvenientLocations(lang, cords) {
        return _ref.apply(this, arguments);
    };
}();
// brand section
var getInnerPagesWithDefaultLocale = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(innerPageName) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getInnerPagesUrl */ .zP(innerPageName, brand, locale)), "get")
            ];
        });
    });
    return function getInnerPagesWithDefaultLocale(innerPageName) {
        return _ref.apply(this, arguments);
    };
}();
// student special content
var getStudentSpecialContent = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(defaultLink, locale, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getStudentSpecialUrl */ .Sh(defaultLink, locale, brand)), "get")
            ];
        });
    });
    return function getStudentSpecialContent(defaultLink, locale, brand) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getCityLandingInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getCityLandingInfo */ .fC(slug, brand, locale)), "get")
            ];
        });
    });
    return function getCityLandingInfo(slug) {
        return _ref.apply(this, arguments);
    };
}();
// city landing page
var getVehicleLandingData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug) {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "as", locale = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getVehicleLandingInfo */ .CZ(slug, brand, locale)), "get")
            ];
        });
    });
    return function getVehicleLandingData(slug) {
        return _ref.apply(this, arguments);
    };
}();
// right units
var getRightUnitInfo = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var brand, locale;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "as", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getRightUnitInfo */ .Zy(brand, locale)), "get")
            ];
        });
    });
    return function getRightUnitInfo() {
        return _ref.apply(this, arguments);
    };
}();
// validate city for facility slug
var getValidityCity = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(slug, brand) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getValidateCity */ .e$(slug, brand)), "get")
            ];
        });
    });
    return function getValidityCity(slug, brand) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1217,1608,1664,3640,9774,2888,179], function() { return __webpack_exec__(12802); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);